import { withOnClickTracking } from 'auto-tracking';
import { rem, styled, theme } from 'design-system';

export const ButtonNew = withOnClickTracking(
  styled('button', {
    margin: 0,
    cursor: 'pointer',
    fontFamily: theme.fonts.sansSerif,
    fontSize: rem(16),
    fontWeight: theme.fontWeights.medium,
    lineHeight: rem(24),
    border: '3px solid white',
    textDecoration: 'none',
    color: theme.colors.white,
    backgroundColor: theme.colors.blue9,

    '&:hover': {
      color: 'white', // Change text color on hover to white
    },

    '&:active': {
      boxShadow: `${theme.shadows.border} ${theme.colors.gray8}, ${theme.shadows.shadow1} ${theme.colors.grayAlpha7}`,
    },

    '&:disabled': {
      color: theme.colors.gray7,
      cursor: 'unset',
    },

    '&:focus-visible': {
      outlineOffset: '2px',
    },

    variants: {
      size: {
        tiny: {
          borderRadius: rem(4),
          fontSize: rem(12),
          paddingTop: rem(0),
          paddingRight: rem(6),
          paddingBottom: rem(0),
          paddingLeft: rem(6),
        },
        small: {
          borderRadius: rem(8),
          fontSize: rem(16),
          paddingTop: rem(12),
          paddingRight: rem(12),
          paddingBottom: rem(12),
          paddingLeft: rem(24),
        },
        big: {
          borderRadius: rem(10),
          fontSize: rem(19),
          paddingTop: rem(16),
          paddingRight: rem(32),
          paddingBottom: rem(16),
          paddingLeft: rem(32),
        },
      },
      fullWidth: {
        true: {
          width: '100%',
          textAlign: 'center',
        },
      },
      color: {
        gray1: {
          backgroundColor: theme.colors.gray1,
          color: theme.colors.gray11,
        },
        yellow: {
          backgroundColor: 'Yellow',
          color: 'Black',
        },
      },
    },

    defaultVariants: {
      size: 'small',
    },
  }),
);
